<div>
  <!--begin::Profile Personal Information-->
  <div class="d-flex flex-row">
    <!--begin::Aside-->
    <div class="flex-row-auto w-250px w-xxl-300px" id="kt_profile_aside" *ngIf="facility?.id">
      <!--begin::Profile Card-->
      <div class="card card-custom card-stretch panel_1">
        <!--begin::Body-->
        <div class="card-body pt-4">
          <!--begin::User-->
          <div
            class="d-flex align-items-center"
            style="margin-bottom: 20px; justify-content: center"
          >
            <span class="symbol symbol-70 symbol-xxl-100 align-self-start align-self-xxl-center">
              <span>
                <div>
                  <div class="image-input image-input-outline image-input-changed">
                    <img
                      class="image-input-wrapper"
                      id="contact_profile"
                      src="{{ facilityProfile }}"
                      style="width: 150px; height: 150px"
                      alt="facilityProfile"
                    />
                    <label
                      *ngIf="!isViewMode"
                      class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow dropdown-toggle dropdown-toggle-split"
                      data-action="change"
                      data-toggle="dropdown"
                      title=""
                      data-original-title="Change avatar"
                    >
                      <i class="fa fa-pen icon-sm text-muted"></i>
                    </label>
                    <span
                      *ngIf="facility.pre_signed_url?.url"
                      class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow magnify-icon"
                      data-action="zoom"
                      (click)="showFacilityPhoto(facility)"
                      matTooltip="Zoom in"
                    >
                      <i class="flaticon-search-magnifier-interface-symbol icon-nm text-muted"></i>
                    </span>
                    <div class="dropdown-menu dropdown-menu-sm dropdown-menu-left">
                      <a class="dropdown-item" (click)="updateProfile()"> Upload photo </a>
                    </div>
                  </div>
                </div>
              </span>
            </span>
          </div>
          <!--end::User-->
          <div>
            <div>
              <div
                style="max-width: 240px; overflow: hidden; margin: auto; text-align: center"
                class="main-cont"
              >
                <p
                  class="font-weight-bolder text-dark-75 mb-0 name-div"
                  [innerText]="facilityName()"
                ></p>
                <p class="text-primary mb-0">{{ facility ? facility.facility_type : '' }}</p>
              </div>
            </div>
          </div>
          <!--begin::Contact-->
          <div class="py-3" style="padding-left: 1.5rem">
            <div
              class="d-flex align-items-center justify-content-left mb-5"
              [matTooltip]="facility ? facility.email : ''"
            >
              <span class="font-weight-bold mr-2">
                <i class="fa flaticon2-black-back-closed-envelope-shape" aria-hidden="true"></i
              ></span>
              <a class="text-muted text-hover-primary ellipsis">{{
                facility ? facility.email : ''
              }}</a>
            </div>
            <div
              class="d-flex align-items-center justify-content-left mb-5"
              matTooltip="Phone Number"
            >
              <span class="font-weight-bold mr-2">
                <i class="fa flaticon2-phone" aria-hidden="true"></i
              ></span>
              <a class="text-muted text-hover-primary">{{
                facility ? (facility.phone | mask : '(000) 000-0000') : ''
              }}</a>
            </div>
            <div
              class="d-flex align-items-center justify-content-left mb-5"
              matTooltip="Primary Contact"
            >
              <span class="font-weight-bold mr-2">
                <i class="fa flaticon2-correct" aria-hidden="true"></i
              ></span>
              <div
                class="text-muted text-hover-primary ellipsis"
                *ngIf="filterContact(facility) as facilities"
                [matTooltip]="'primary contacts: ' + getFullNameList(facility.entity_contacts)"
              >
                {{ getFullNameList(facility.entity_contacts) }}
              </div>
            </div>
          </div>
          <!--end::Contact-->
        </div>
        <!--end::Body-->
      </div>
      <!--end::Profile Card-->
      <!--begin::Profile Card-->
      <div class="card card-custom card-stretch panel_2">
        <!--begin::Body-->
        <div class="card-body pt-4">
          <!--begin::Nav-->
          <div class="navi navi-bold navi-hover navi-active navi-link-rounded">
            <ng-container
              *ngFor="let tab of tabs"
              [ngTemplateOutlet]="navi_item"
              [ngTemplateOutletContext]="{ tab: tab }"
            ></ng-container>
            <ng-template #navi_item let-tab="tab">
              <div *ngxPermissionsOnly="tab.permission" class="navi-item mb-2 clickable">
                <a
                  class="navi-link py-4"
                  [ngClass]="{ active: tab.active }"
                  (click)="changeTab(tab.index)"
                >
                  <span class="navi-icon mr-2">
                    <i class="{{ tab.icon }}"></i>
                  </span>
                  <span class="navi-text font-size-lg">{{ tab.label }}</span>
                </a>
              </div>
            </ng-template>
          </div>
          <!--end::Nav-->
        </div>
        <!--end::Body-->
      </div>
      <!--end::Profile Card-->
    </div>
    <!--end::Aside-->
    <!--begin::Content-->
    <div
      class="flex-row-fluid"
      [ngStyle]="facility?.id ? { 'margin-left': '8px' } : { 'margin-left': '0' }"
      style="min-height: 1350px"
    >
      <!--begin::Card-->
      <div class="card card-custom card-stretch" *ngIf="tabs[0].active">
        <!--begin::Header-->
        <div class="card-header py-3">
          <div class="card-title align-items-start flex-column">
            <h3 class="card-label font-weight-bolder text-dark">
              {{ facility?.id ? facility.name + '’s Facility Information' : 'New Facility' }}
            </h3>
            <span class="text-muted font-weight-bold font-size-sm mt-1"
              >{{ facility?.id ? 'Update ' : 'Add ' }} facility information</span
            >
          </div>
          <div class="card-toolbar">
            <a
              ktBackButton
              class="btn btn-secondary mr-2"
              mat-raised-button
              matTooltip="{{ 'AUTH.INPUT.BACK' | translate }}"
              *ngIf="!entity_id"
            >
              <i class="la la-arrow-left"></i>
              <span class="hidden-mobile"> {{ 'AUTH.INPUT.BACK' | translate }}</span>
            </a>
            <ng-template ngxPermissionsOnly="canEditFacility">
              <a
                *ngIf="isViewMode"
                (click)="editFacility(facility)"
                class="btn btn-secondary mr-2"
                mat-raised-button
                matTooltip="Edit Facility"
              >
                <span class="hidden-mobile" translate="GLOBAL.EDIT">Edit</span>
              </a>
            </ng-template>
            <a
              href="javascript:"
              *ngIf="facility && !facility.id"
              class="btn btn-secondary mr-2"
              (click)="reset()"
              mat-raised-button
              matTooltip="{{ 'AUTH.RESET.BUTTON' | translate }}"
            >
              <i class="la la-cog"></i>
              <span class="hidden-mobile">{{ 'AUTH.RESET.BUTTON' | translate }}</span>
            </a>
            <a
              href="javascript:"
              *ngIf="!isViewMode"
              class="btn btn-primary mr-2"
              color="primary"
              (click)="submit()"
              mat-raised-button
              matTooltip="Save & Continue"
            >
              <span class="hidden-mobile"> {{ 'AUTH.INPUT.SAVE' | translate }}</span>
            </a>
          </div>
        </div>
        <!--end::Header-->

        <!--begin::Form-->
        <form class="form" [formGroup]="facilityForm" *ngIf="loadingData">
          <kt-alert
            *ngIf="hasFormErrors"
            type="warn"
            [showCloseButton]="true"
            [duration]="10000"
            (closeAl)="onAlertClose()"
          >
            {{ 'AUTH.VALIDATION.INVALID_OR_REQUIRED' | translate }}
          </kt-alert>
          <kt-alert
            *ngIf="hasSubmissionErrors && !hasFormErrors"
            type="warn"
            [duration]="30000"
            [showCloseButton]="true"
            (closeAl)="onAlertClose()"
          >
            <ul>
              <li *ngFor="let msg of submissionErrorObj">{{ msg.error | translate }}</li>
            </ul>
          </kt-alert>
          <!--begin::Body-->
          <div class="card-body">
            <div class="row">
              <h5 class="font-weight-bold mb-6">{{ 'FACILITY.DEMOGRAPHICS' | translate }}</h5>
            </div>
            <div class="form-group row">
              <div class="col-lg-6 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'FACILITY.NAME' | translate }}</mat-label>
                  <input matInput placeholder="Name" formControlName="name" required />
                  <mat-error
                    >{{ 'FACILITY.NAME' | translate }}
                    <strong>{{ 'AUTH.VALIDATION.REQUIREDD' | translate }}</strong>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-6 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'FACILITY.EMAIL' | translate }}</mat-label>
                  <input type="email" matInput placeholder="Enter Email" formControlName="email" />
                  <mat-error
                    >{{ 'FACILITY.EMAIL' | translate }}
                    <strong>{{ 'AUTH.VALIDATION.REQUIREDD' | translate }}</strong>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-6 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'FACILITY.CODE' | translate }}</mat-label>
                  <input matInput placeholder="facility code" formControlName="facility_code" />
                  <mat-error
                    >{{ 'FACILITY.CODE' | translate }}
                    <strong>{{ 'AUTH.VALIDATION.REQUIREDD' | translate }}</strong>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-6 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'FACILITY.FACILITY_TYPE' | translate }}</mat-label>
                  <input matInput placeholder="facility type" formControlName="facility_type" />
                </mat-form-field>
              </div>
              <div class="col-lg-6 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'FACILITY.PHONE' | translate }}</mat-label>
                  <input
                    matInput
                    placeholder="phone"
                    formControlName="phone"
                    maxlength="14"
                    ktAppPhoneMask
                  />
                  <mat-error *ngIf="isControlHasError('phone', 'pattern')">
                    <strong>{{ 'FACILITY.REQUIREDPHONE' | translate }}</strong>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-3 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid gl-block" appearance="fill">
                  <mat-label>Office Number</mat-label>
                  <input
                    matInput
                    placeholder="Enter Office Number"
                    ktAppPhoneMask
                    formControlName="office_number"
                    autocomplete="kt-patient-office-number"
                  />
                </mat-form-field>
              </div>
              <div class="col-lg-3 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid gl-block" appearance="fill">
                  <mat-label>Extension</mat-label>
                  <input
                    matInput
                    placeholder="Enter Extension"
                    maxlength="7"
                    formControlName="extension"
                    autocomplete="kt-patient-extension"
                  />
                  <mat-hint><strong>Must be less than 7 digit</strong></mat-hint>
                </mat-form-field>
              </div>
              <div class="col-lg-3 kt-margin-bottom-20-mobile">
                <div class="mat-form-field-fluid">
                  <mat-label class="row ml-1" translate="FACILITY.STATUS">Contact Status</mat-label>
                  <mat-slide-toggle class="mr-2" formControlName="is_active"></mat-slide-toggle>
                  <mat-hint align="start">
                    <strong>{{ getStatusString() }}</strong>
                  </mat-hint>
                </div>
              </div>
            </div>
            <div class="row">
              <h5 class="font-weight-bold mb-6">Address</h5>
            </div>
            <div class="form-group row">
              <div class="col-lg-12 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'DOCTOR.INPUT.URBANIZATION' | translate }}</mat-label>
                  <input
                    matInput
                    formControlName="urbanization"
                    [ngModel]="urbanizationValue"
                    (ngModelChange)="urbanizationValue = $event ? $event.toUpperCase() : ''"
                  />
                  <mat-error *ngIf="isControlHasError('urbanization', 'maxlength')">
                    Maximum length is 48 character
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-12 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="CONTACT.FORM.ADDRESS1">Address1</mat-label>
                  <input
                    matInput
                    formControlName="address_1"
                    [ngModel]="Address1Value"
                    (ngModelChange)="Address1Value = $event ? $event.toUpperCase() : ''"
                    required
                  />
                  <mat-error *ngIf="isControlHasError('address_1', 'maxlength')">
                    Maximum length is 48 character
                  </mat-error>
                  <mat-error *ngIf="isControlHasError('address_1', 'required')">
                    Address1 is required
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-12 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="CONTACT.FORM.ADDRESS2">Address2</mat-label>
                  <input
                    matInput
                    formControlName="address_2"
                    [ngModel]="Address2Value"
                    (ngModelChange)="Address2Value = $event ? $event.toUpperCase() : ''"
                  />
                  <mat-error *ngIf="isControlHasError('address_2', 'maxlength')">
                    Maximum length is 48 character
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="CONTACT.FORM.CITY">City</mat-label>
                  <input
                    matInput
                    formControlName="city"
                    [ngModel]="cityValue"
                    (ngModelChange)="cityValue = $event ? $event.toUpperCase() : ''"
                    required
                  />
                  <mat-error *ngIf="isControlHasError('city', 'maxlength')">
                    Maximum length is 30 character
                  </mat-error>
                  <mat-error *ngIf="isControlHasError('city', 'required')">
                    City is required
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="CONTACT.FORM.STATE">State</mat-label>
                  <mat-select formControlName="state" required>
                    <mat-option value="AL">AL</mat-option>
                    <mat-option value="AK">AK</mat-option>
                    <mat-option value="AR">AR</mat-option>
                    <mat-option value="AZ">AZ</mat-option>
                    <mat-option value="CA">CA</mat-option>
                    <mat-option value="CO">CO</mat-option>
                    <mat-option value="CT">CT</mat-option>
                    <mat-option value="DC">DC</mat-option>
                    <mat-option value="DE">DE</mat-option>
                    <mat-option value="FL">FL</mat-option>
                    <mat-option value="GA">GA</mat-option>
                    <mat-option value="HI">HI</mat-option>
                    <mat-option value="IA">IA</mat-option>
                    <mat-option value="ID">ID</mat-option>
                    <mat-option value="IL">IL</mat-option>
                    <mat-option value="IN">IN</mat-option>
                    <mat-option value="KS">KS</mat-option>
                    <mat-option value="KY">KY</mat-option>
                    <mat-option value="LA">LA</mat-option>
                    <mat-option value="MA">MA</mat-option>
                    <mat-option value="MD">MD</mat-option>
                    <mat-option value="ME">ME</mat-option>
                    <mat-option value="MI">MI</mat-option>
                    <mat-option value="MN">MN</mat-option>
                    <mat-option value="MO">MO</mat-option>
                    <mat-option value="MS">MS</mat-option>
                    <mat-option value="MT">MT</mat-option>
                    <mat-option value="NC">NC</mat-option>
                    <mat-option value="NE">NE</mat-option>
                    <mat-option value="NH">NH</mat-option>
                    <mat-option value="NJ">NJ</mat-option>
                    <mat-option value="NM">NM</mat-option>
                    <mat-option value="NV">NV</mat-option>
                    <mat-option value="NY">NY</mat-option>
                    <mat-option value="ND">ND</mat-option>
                    <mat-option value="OH">OH</mat-option>
                    <mat-option value="OK">OK</mat-option>
                    <mat-option value="OR">OR</mat-option>
                    <mat-option value="PA">PA</mat-option>
                    <mat-option value="PR">PR</mat-option>
                    <mat-option value="RI">RI</mat-option>
                    <mat-option value="SC">SC</mat-option>
                    <mat-option value="SD">SD</mat-option>
                    <mat-option value="TN">TN</mat-option>
                    <mat-option value="TX">TX</mat-option>
                    <mat-option value="UT">UT</mat-option>
                    <mat-option value="VT">VT</mat-option>
                    <mat-option value="VA">VA</mat-option>
                    <mat-option value="WA">WA</mat-option>
                    <mat-option value="WI">WI</mat-option>
                    <mat-option value="WV">WV</mat-option>
                    <mat-option value="WY">WY</mat-option>
                  </mat-select>
                  <mat-error *ngIf="isControlHasError('state', 'required')">
                    State is required
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="CONTACT.FORM.ZIP">Zip</mat-label>
                  <input
                    matInput
                    formControlName="zip"
                    maxlength="10"
                    [ngModel]="zipValue"
                    (ngModelChange)="zipValue = $event ? putDash($event) : ''"
                    required
                  />
                  <mat-error *ngIf="isControlHasError('zip', 'required')">
                    Zip Code is required
                  </mat-error>
                  <mat-error *ngIf="isControlHasError('zip', 'pattern')">
                    Zip Code is invalid
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <h5 class="font-weight-bold mb-6">{{ 'FACILITY.OTHER_DETAILS' | translate }}</h5>
            </div>
            <div class="form-group row">
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'FACILITY.DAY_SUPPLY' | translate }}</mat-label>
                  <input matInput placeholder="days_supply" formControlName="days_supply" />
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'FACILITY.NPI' | translate }}</mat-label>
                  <input matInput placeholder="NPI" formControlName="npi" />
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'FACILITY.FILL_BY_ROBOT' | translate }}</mat-label>
                  <input matInput placeholder="filled_by_robot" formControlName="filled_by_robot" />
                  <mat-error
                    >{{ 'FACILITY.FILL_BY_ROBOT' | translate }}
                    <strong>{{ 'AUTH.VALIDATION.REQUIREDD' | translate }}</strong>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'FACILITY.FILL_UPTO' | translate }}</mat-label>
                  <!-- <input matInput placeholder="filled upto" formControlName="filled_up_to"/>  -->
                  <input matInput [matDatepicker]="picker" formControlName="filled_up_to" />
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                  <mat-error
                    >{{ 'FACILITY.FILL_UPTO' | translate }}
                    <strong>{{ 'AUTH.VALIDATION.REQUIREDD' | translate }}</strong>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'FACILITY.CYCLE_FILL' | translate }}</mat-label>
                  <input matInput placeholder="cycle fill" formControlName="cycle_fill" />

                  <mat-error
                    >{{ 'FACILITY.CYCLE_FILL' | translate }}
                    <strong>{{ 'AUTH.VALIDATION.REQUIREDD' | translate }}</strong>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'FACILITY.LEAD_DAYS' | translate }}</mat-label>
                  <input matInput type="number" formControlName="lead_days" />
                  <mat-error
                    >{{ 'FACILITY.LEAD_DAYS' | translate }}
                    <strong>{{ 'AUTH.VALIDATION.REQUIREDD' | translate }}</strong>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'FACILITY.LEAD_DAYS_TO_FILL' | translate }}</mat-label>
                  <input matInput type="number" formControlName="lead_days_to_bill" />
                  <mat-error
                    >{{ 'FACILITY.LEAD_DAYS_TO_FILL' | translate }}
                    <strong>{{ 'AUTH.VALIDATION.REQUIREDD' | translate }}</strong>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'FACILITY.LEAD_DAYS_TO_DELIVARY' | translate }}</mat-label>
                  <input matInput type="number" formControlName="lead_days_to_delivery" />

                  <mat-error
                    >{{ 'FACILITY.LEAD_DAYS_TO_DELIVARY' | translate }}
                    <strong>{{ 'AUTH.VALIDATION.REQUIREDD' | translate }}</strong>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-12 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'FACILITY.NOTE' | translate }}</mat-label>
                  <textarea matInput placeholder="note" formControlName="note"></textarea>
                  <mat-error
                    >{{ 'FACILITY.NOTE' | translate }}
                    <strong>{{ 'VALIDATION.REQUIREDD' | translate }}</strong>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <h5 class="font-weight-bold mb-6">{{ 'MESSAGE.INPUT.TAG' | translate }}</h5>
            </div>
            <div class="form-group row">
              <div class="col-lg-12 kt-margin-bottom-20-mobile">
                <kt-tags
                  [autocompleteEntity]="'FACILITY'"
                  [controlObject]="tags"
                  [appearance]="'fill'"
                  [value]="tags$"
                  category="Entity"
                ></kt-tags>
              </div>
            </div>
            <div class="row">
              <h5 class="font-weight-bold mb-6">{{ 'PATIENT.INPUT.LAST_MODIFIED' | translate }}</h5>
            </div>
            <div class="form-group row">
              <div class="ml-5">
                <mat-label>{{ facility.last_modified_user }}</mat-label>
              </div>
            </div>
          </div>
          <!--end::Body-->
        </form>
        <!--end::Form-->
      </div>
      <!--begin::Card-->
      <div class="card card-custom card-stretch" *ngIf="tabs[1].active">
        <div class="until-they">
          <kt-entity-relationships-list
            [entity_type]="'facilities'"
            [entity_id]="facility?.id"
            (openList)="closeDialog($event)"
            (navigateToContact)="closeDialog($event)"
          ></kt-entity-relationships-list>
        </div>
      </div>
      <!--begin::Card-->
      <div class="card card-custom card-stretch" *ngIf="tabs[2].active">
        <div class="until-they">
          <kt-note-list
            [entityId]="facility?.id"
            [entityType]="NoteEntityType.FACILITY"
          ></kt-note-list>
        </div>
      </div>
      <!--begin::Card-->
      <div class="card card-custom card-stretch" *ngIf="tabs[3].active">
        <div class="until-they">
          <kt-patients-list
            [canvas]="!!entity_id"
            [fromFacility]="true"
            [entity_id_for_task_list]="facility?.id"
          ></kt-patients-list>
        </div>
      </div>
      <!--begin::Card-->
      <div class="card card-custom card-stretch" *ngIf="tabs[4].active">
        <!--begin::Header-->
        <div class="card-header py-3">
          <div class="card-title align-items-start">
            <h3 class="card-label" style="align-self: center">Other Details</h3>
          </div>
          <div class="card-toolbar">
            <a
              href="javascript:"
              class="btn btn-primary mr-2"
              color="primary"
              (click)="submit()"
              mat-raised-button
              matTooltip="Save & Continue"
            >
              <span class="hidden-mobile"> {{ 'AUTH.INPUT.SAVE' | translate }}</span>
            </a>
          </div>
        </div>
        <!--end::Header-->
        <div *ngIf="facility">
          <form
            [formGroup]="facilityForm"
            class="form form-group-seperator-dashed"
            *ngIf="loadingData"
          >
            <div class="p-5">
              <div class="form-group row">
                <div class="col-lg-12 card-header-doctor-form">
                  <h4>Geolocation</h4>
                </div>
                <div class="col-lg-4 kt-margin-bottom-20-mobile">
                  <mat-form-field class="mat-form-field-fluid" appearance="fill">
                    <mat-label>Enter a plus code,address or (Longitude,Latitude)</mat-label>
                    <input
                      matInput
                      placeholder="Enter a plus code or an address"
                      formControlName="geolocation_address"
                    />
                  </mat-form-field>
                  <mat-form-field class="mat-form-field-fluid" appearance="fill">
                    <mat-label>Plus Code</mat-label>
                    <input matInput placeholder="Plus Code" formControlName="plus_code" />
                  </mat-form-field>
                  <mat-form-field class="mat-form-field-fluid" appearance="fill">
                    <mat-label>Latitude</mat-label>
                    <input matInput placeholder="Latitude" formControlName="latitude" />
                  </mat-form-field>
                  <mat-form-field class="mat-form-field-fluid" appearance="fill">
                    <mat-label>Longitude</mat-label>
                    <input matInput placeholder="Longitude" formControlName="longitude" />
                  </mat-form-field>
                  <a
                    (click)="searchForGeolocation()"
                    class="btn btn-primary"
                    color="primary"
                    mat-raised-button
                    matTooltip="Find GeoLocation"
                  >
                    <span>Find GeoLocation</span>
                  </a>
                  <a
                    (click)="resetGeolocation()"
                    class="ml-2 btn btn-secondary"
                    mat-raised-button
                    matTooltip="Reset"
                  >
                    <span class="hidden-mobile">Reset</span>
                  </a>
                </div>
                <div class="col-lg-8 kt-margin-bottom-20-mobile">
                  <agm-map
                    [zoom]="15"
                    [latitude]="facilityForm.get('latitude').value"
                    [longitude]="facilityForm.get('longitude').value"
                  >
                    <agm-marker
                      [latitude]="facilityForm.get('latitude').value"
                      (dragEnd)="markerDragEnd($event)"
                      [longitude]="facilityForm.get('longitude').value"
                      [markerDraggable]="true"
                    ></agm-marker>
                  </agm-map>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <!--begin::Card-->
      <div class="card card-custom card-stretch" *ngIf="tabs[5].active">
        <div class="until-they">
          <kt-sales-teams-list
            [fromFacility]="true"
            [entity_id_for_task_list]="facility?.id"
          ></kt-sales-teams-list>
        </div>
      </div>
      <div *ngIf="tabs[6].active" class="card card-custom card-stretch">
        <div class="until-they">
          <kt-document-list [entityId]="facility?.id"></kt-document-list>
        </div>
      </div>
      <div *ngIf="tabs[7].active" class="card card-custom card-stretch">
        <div class="until-they">
          <kt-affiliations-list></kt-affiliations-list>
        </div>
      </div>
    </div>
    <!--end::Content-->
  </div>
  <!--end::Profile Personal Information-->
</div>
